var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchIconLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.668 8.015c5.36.271 9.623 4.703 9.623 10.13l-.013.522a10.088 10.088 0 01-1.657 5.055l6.018 6.018v2.173L30.523 32l-6.013-5.955a10.103 10.103 0 01-6.364 2.245l-.522-.013c-5.187-.263-9.346-4.422-9.608-9.61L8 18.145C8.001 12.543 12.544 8 18.147 8l.521.015zM18.147 10a8.146 8.146 0 10.001 16.293A8.146 8.146 0 0018.146 10z",
    fill: "#fff"
  })));
}

export default SvgSearchIconLarge;